export function Tension() {
  return (
    <section
      data-testid="tension-section"
      className="relative overflow-hidden"
      style={{
        background: "linear-gradient(180deg, #FAFAF8 0%, #F8F7F5 50%, #FAFAF8 100%)",
      }}
    >
      <div
        aria-hidden
        className="absolute top-0 right-0 w-[500px] h-[500px] opacity-[0.03]"
        style={{ background: "radial-gradient(circle, #159E9A 0%, transparent 70%)" }}
      />
      <div className="max-w-3xl mx-auto px-6 md:px-10 py-12 md:py-14 pb-6 md:pb-8 relative z-[1]">
        <h2 className="font-display text-[41px] sm:text-[55px] lg:text-[69px] leading-[1.08] tracking-tight text-[#1C1917] reveal">
          Have You Misplaced Your Joy?
        </h2>
        <div className="mt-8 space-y-6 text-[20px] text-[#57534E] leading-relaxed reveal">
          <p>Not in a "my life is ruined" kind of way.</p>
          <p>
            More like the way you misplace your keys.
            <br />
            You check your bag.
            <br />
            The counter.
            <br />
            The car.
          </p>
          <p>You retrace your steps.</p>
          <p>
            And then you realize —
            <br />
            they were there the whole time.
          </p>
          <p className="font-display text-2xl text-[#1C1917]">Joy isn't gone.</p>
          <p>
            But somewhere along the way, you adjusted to a version of "fine" that
            made sense… and stopped checking whether it still fit.
          </p>
          <p>That quiet friction?</p>
          <p className="font-display text-2xl text-[#159E9A]">That's the gap.</p>
        </div>
      </div>
    </section>
  );
}
